import { mapGetters, mapActions } from 'vuex';
import format from '@/common/utilities/format';

export default {
    name: 'mvtSnapshot',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            outLineSize: null,
            loaded: false,
            title: '',
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        snapshot() {
            var date = new Date();
            date.setMonth(date.getMonth() - 1);
            var monthName = date.toLocaleString('en-us', { month: 'long' });
            var yearName = date.getFullYear();
            this.title = `Market Snapshot For ${monthName} ${yearName} <br> ${this.glb.geo.city || this.glb.geo.county}, ${this.glb.geo.state}`;
            var data = {
                singleDesc: '',
                singlePriceMedian: 'N/A',
                singleSizeMedian: 'N/A',
                singleDom: 'N/A',
                singleInventory: 'N/A',
                singlePricePerSqftMedian: 'N/A',
                condoDesc: '',
                condoPriceMedian: 'N/A',
                condoSizeMedian: 'N/A',
                condoDom: 'N/A',
                condoInventory: 'N/A',
                condoPricePerSqftMedian: 'N/A',
                allDesc: '',
                allDom: 'N/A',
                allSizeMedian: 'N/A',
                allHighestPrice: 'N/A',
                allLowestPrice: 'N/A',
                allHighestSqft: 'N/A',
                allLowestSqft: 'N/A',
                allInventory: 'N/A',
                allPricePerSqftMedian: 'N/A',
            };
            if (this.data) {
                if (this.data.singleTypeMedianListPrice > 0) {
                    data.singlePriceMedian = '$' + format.friendlyPrice(this.data.singleTypeMedianListPrice);
                }
                if (this.data.singleTypeMedianHouseSize > 0) {
                    data.singleSizeMedian = format.formatNumberByComma(this.data.singleTypeMedianHouseSize);
                }
                if (this.data.singleTypeMedianDom > 0) {
                    data.singleDom = this.data.singleTypeMedianDom;
                }
                if (this.data.singleTypeTotalInventory > 0) {
                    data.singleInventory = this.data.singleTypeTotalInventory;
                }
                if (this.data.singleTypeMedianPricePerSqftHouse > 0) {
                    data.singlePricePerSqftMedian = format.friendlyPrice(this.data.singleTypeMedianPricePerSqftHouse);
                }

                if (this.data.condoTypeMedianListPrice > 0) {
                    data.condoPriceMedian = '$' + format.friendlyPrice(this.data.condoTypeMedianListPrice);
                }
                if (this.data.condoTypeMedianHouseSize > 0) {
                    data.condoSizeMedian = format.formatNumberByComma(this.data.condoTypeMedianHouseSize);
                }
                if (this.data.condoTypeMedianDom > 0) {
                    data.condoDom = this.data.condoTypeMedianDom;
                }
                if (this.data.condoTypeTotalInventory > 0) {
                    data.condoInventory = this.data.condoTypeTotalInventory;
                }
                if (this.data.condoTypeMedianPricePerSqftHouse > 0) {
                    data.condoPricePerSqftMedian = format.friendlyPrice(this.data.condoTypeMedianPricePerSqftHouse);
                }

                if (this.data.allTypeMedianListPrice > 0) {
                    data.allPriceMedian = '$' + format.friendlyPrice(this.data.allTypeMedianListPrice);
                }
                if (this.data.allTypeMedianHouseSize > 0) {
                    data.allSizeMedian = format.formatNumberByComma(this.data.allTypeMedianHouseSize);
                }
                if (this.data.allTypeMedianDom > 0) {
                    data.allDom = this.data.allTypeMedianDom;
                }
                if (this.data.allTypeTotalInventory > 0) {
                    data.allInventory = this.data.allTypeTotalInventory;
                }
                if (this.data.allTypeMedianPricePerSqftHouse > 0) {
                    data.allPricePerSqftMedian = format.friendlyPrice(this.data.allTypeMedianPricePerSqftHouse);
                }
                if (this.data.mostExpensiveHouse >= 0) {
                    data.allHighestPrice = '$' + format.friendlyPrice(this.data.mostExpensiveHouse);
                }
                if (this.data.leastExpensiveHouse >= 0) {
                    data.allLowestPrice = '$' + format.friendlyPrice(this.data.leastExpensiveHouse);
                }
                if (this.data.highestSqftHouse >= 0) {
                    data.allHighestSqft = format.formatNumberByComma(this.data.highestSqftHouse);
                }
                if (this.data.lowestSqftHouse >= 0) {
                    data.allLowestSqft = format.formatNumberByComma(this.data.lowestSqftHouse);
                }

                if (data.allInventory > 0) {
                    data.allDesc = `Based on ${data.allInventory} homes, ranging from ${data.allLowestPrice} to ${data.allHighestPrice} and ${data.allLowestSqft} Sqft to ${data.allHighestSqft} Sqft`;
                }

                if (data.singleInventory > 0) {
                    data.singleDesc = `Based on ${data.singleInventory} houses`;
                }

                if (data.condoInventory > 0) {
                    data.condoDesc = `Based on ${data.condoInventory} condo/townhomes`;
                }
            }
            return data;
        },
        hasCondoTownhouseData() {
            if (!this.data.condoTypeMedianPricePerSqftHouse && !this.data.condoTypeMedianDom && !this.data.condoTypeMedianHouseSize && !this.data.condoTypeMedianListPrice) {
                return false;
            } else {
                return true;
            }
        },
    },
    methods: {
        ...mapActions('glb', ['getBoundaries']),
    },
};
